import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useFormik } from "formik";
import { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { ContextOperation } from "../../context/OperationContext";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import useSnackbar from "../../hooks/useSnackbar";
import FormInput from "../common/FormInput";
import MonySymbolsComponets from "../common/MonySymbolsComponents";
import { nameof } from "../common/ObjectUtils";
import DamagePriceService from "./service/damagePrice.action";
import { DamageTypes } from "./Types";
interface Props {
  open: boolean;
  onClose: () => void;
  damageId: any;
}

const DetailsDamagePriceList = (props: Props) => {
  const snackbar = useSnackbar();
  const { setLoading } = useContext(ContextOperation);
  const t = useOperationTranslation();
  const form = useForm<DamageTypes.DetailsDamageFilter>({
    defaultValues: {},
  });
  const { tenant } = useContext(ContextOperation);


  useMemo(() => {

    if (props.damageId != null) {

      setLoading(true);
      DamagePriceService.get
        .getDamagePriceListDetails(tenant, props.damageId)
        .then((response) => {
          form.setValue("formCode", response.formCode);
          form.setValue("label", response.label);
          form.setValue("plate", response.plate);
          form.setValue("severity", response.severity);
          form.setValue("open",response.open);
          form.setValue("price", response.price);
          form.setValue("damageDate", response.damageDate);
          form.setValue("currency", response.currency);
        });
      setLoading(false);
    }
  }, [props.damageId]);

  
  return (
    <Mui.Dialog
      open={props.open}
      onClose={props.onClose}
      fullWidth
       maxWidth="md"
       PaperProps={{
        sx: {
          maxWidth: "1108px",
          height: "294px",
        },
      }}
      // width ='1108px'
    >
      <Mui.DialogTitle>
        <Mui.Grid container alignItems="center">
          <Mui.Grid item xs="auto">
            <Mui.Typography variant="h6">
              {t("damageList.detailsDamageList.title")}
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid item xs="auto" marginLeft="auto">
            <Mui.IconButton onClick={props.onClose}>
              <MuiIcons.Close />
            </Mui.IconButton>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogTitle>
      <Mui.DialogContent>
        <form>
          <Mui.Grid container spacing="16px" height="100px">
            <Mui.Grid item md={3} xs={12}>
              <Mui.Grid>
                <Mui.InputLabel>{t("damageList.fields.formCode")}</Mui.InputLabel>
                <FormInput
                  type="text"
                  name={nameof<DamageTypes.DetailsDamageFilter>(
                    "formCode"
                  )}
                  value={form.watch("formCode")}
                  fullWidth
                  disabled
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <Mui.Grid>
                <Mui.InputLabel>{t("damageList.fields.part")}</Mui.InputLabel>

                <FormInput
                  type="text"
                  name={nameof<DamageTypes.DetailsDamageFilter>("label")}
                  value={form.watch("label")}
                  fullWidth
                  disabled
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <Mui.Grid item>
                <Mui.InputLabel>{t("damageList.fields.plate")}</Mui.InputLabel>
                <FormInput
                  type="text"
                  name={nameof<DamageTypes.DetailsDamageFilter>("plate")}
                  value={form.watch("plate")}
                  fullWidth
                  disabled
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <Mui.Grid item>
                <Mui.InputLabel>
                  {t("damageList.fields.severity")}
                </Mui.InputLabel>
                <FormInput
                  type="text"
                  name={nameof<DamageTypes.DetailsDamageFilter>(
                    "severity"
                  )}
                  value={form.watch("severity")}
                  fullWidth
                  disabled
                />
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container spacing="16px" height="100px">
            <Mui.Grid item md={3} xs={12}>
              <Mui.Grid item>
                <Mui.InputLabel>{t("damageList.fields.open")}</Mui.InputLabel>
                <FormInput
                  type="text"
                  name={nameof<DamageTypes.DetailsDamageFilter>("open")}
                  value={form.watch("open")? t("damageList.fields.opens") : t("damageList.fields.closed")}
                  fullWidth
                  disabled
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <Mui.Grid item>
                <Mui.InputLabel>
                  {t("damageList.fields.damageData")}
                </Mui.InputLabel>
                <FormInput
                  type="date" 
                  inputFormat={"DD/MM/YYYY"}
                  name={nameof<DamageTypes.DetailsDamageFilter>(
                    "damageDate"
                  )}
                  value={form.watch("damageDate")}
                  fullWidth
                  disabled
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <Mui.Grid item>
                <Mui.InputLabel>{t("damageList.fields.price")}</Mui.InputLabel>
                <Mui.TextField
               name={nameof<DamageTypes.DetailsDamageFilter>("price")}
                fullWidth
                disabled
                value={form.watch("price")}
                InputProps={{
                  startAdornment: (
                    <Mui.InputAdornment    position="start">
                      <MonySymbolsComponets
                         changeColor ={true}
                        symbols={form.watch("currency")}
                      />
                    </Mui.InputAdornment>
                  ),
                }}
              />
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Grid>
        </form>
      </Mui.DialogContent>
    </Mui.Dialog>
  );
};

export default DetailsDamagePriceList;
